import { gql } from '../../../../../hooks'

export const READ_BRANDS = gql`
  query AdministrationReadMachineBrands($id: ID!) {
    aRead(path: "machine/brands", id: $id) {
    }
  }
`

export const DELETE_BRANDS = gql`
  mutation AdministrationDeleteMachineBrands($id: ID!) {
    aDelete(path: "machine/brands", id: $id) {
    }
  }
`
